<div class="mt-3" *ngIf="tiposVehiculo?.length > 0">
    <ca-card>
        <div ca-card-title>{{'AUTOS.BUSCADOR_MODELOS.TIPOS_VEHICULO.TITULO' | translate}}</div>
        <div ca-card-content>
            <div class="autos-contenedor-imagenes ">
                <div class="row">
                <ng-container *ngFor="let tipoVehiculo of tiposVehiculo; let i = index">
                    <div class="col-12 autos-contenedor-imagen">
                        <div class="row autos-centrado"> 
                            <img class="autos-busqueda-img tipo-vehiculo-img"
                                [src]="'assets/images/tipoVehiculo/' + tipoVehiculo.imagen" 
                                (click)="seleccionarTipoVehiculo(tipoVehiculo)"/>
                        </div>
                        <div class="row autos-centrado"> 
                            <span>{{('AUTOS.BUSCADOR_MODELOS.TIPOS_VEHICULO.CAT_'+ tipoVehiculo.categoria)| translate}}</span>
                        </div>
                        <div class="row autos-centrado"> 
                            <span >{{tipoVehiculo.categoria}} {{'AUTOS.BUSCADOR_MODELOS.TIPOS_VEHICULO.CATEGORIA' | translate}}</span>
                            <span caTooltip="{{('AUTOS.BUSCADOR_MODELOS.TIPOS_VEHICULO.TOOLTIP_CAT_'+ tipoVehiculo.categoria) | translate}}" class="material-icons">help</span>
                        </div>
                    </div>
                </ng-container>
                </div>
            </div>
        </div>
    </ca-card>
</div>